import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _taggedTemplateLiteral from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { gql } from "@apollo/client";
import * as y from "yup";
import ViewingArticle from "@/lib/ViewingArticle";
import { isDateRangeIn } from "./helper";
import { CONTRACTABLE_BUFFER, PURCHASABLE_BUFFER } from "@/lib/constants";
export var typeDef = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  type RecommendArticle @cacheControl(scope: PRIVATE, maxAge: 0) {\n    courses: [Course]\n    products: [Product]\n  }\n\n  type Query {\n    recommendArticle: RecommendArticle\n  }\n\n  type Mutation {\n    updateRecommendArticle(type: String!, id: [Int]): RecommendArticle\n    clearRecommendArticle: RecommendArticle\n  }\n"])));
/**
 * contractAllowed.
 *
 * コースが販売期間ないか判定
 *
 * @param {Course} course
 */

function contractAllowed(course) {
  if (!course) return false;
  return isDateRangeIn(course.contractable_start_at, course.contractable_end_at, {
    buffer: CONTRACTABLE_BUFFER,
    default: true
  });
}
/**
 * purchaseAllowed.
 *
 * Productが販売期間ないか判定
 *
 * @param {Product} product
 */


function purchaseAllowed(product) {
  if (!product) return false;
  return isDateRangeIn(product === null || product === void 0 ? void 0 : product.sales_start_at, product === null || product === void 0 ? void 0 : product.sales_end_at, {
    buffer: PURCHASABLE_BUFFER,
    default: true
  });
}
/**
 * normalization.
 *
 * データの正規化
 *
 * @param {Object} recommend
 * @param {string} recommend.type - svod or tvod
 * @param {number[]} recommend.id
 * @param {Object} dataSources
 */


function normalization(_x, _x2) {
  return _normalization.apply(this, arguments);
}

function _normalization() {
  _normalization = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(recommend, dataSources) {
    var response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            response = {
              courses: null,
              products: null
            };
            _context8.next = 3;
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
              var courseIds, promises;
              return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                while (1) {
                  switch (_context5.prev = _context5.next) {
                    case 0:
                      if (!((recommend === null || recommend === void 0 ? void 0 : recommend.type) !== "svod")) {
                        _context5.next = 2;
                        break;
                      }

                      return _context5.abrupt("return", null);

                    case 2:
                      courseIds = Array.isArray(recommend.id) ? recommend.id : [recommend.id];
                      promises = courseIds.map( /*#__PURE__*/function () {
                        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
                          var course;
                          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                            while (1) {
                              switch (_context4.prev = _context4.next) {
                                case 0:
                                  _context4.next = 2;
                                  return dataSources.courses.courseById(id);

                                case 2:
                                  course = _context4.sent;

                                  if (!contractAllowed(course)) {
                                    _context4.next = 7;
                                    break;
                                  }

                                  return _context4.abrupt("return", course);

                                case 7:
                                  return _context4.abrupt("return", null);

                                case 8:
                                case "end":
                                  return _context4.stop();
                              }
                            }
                          }, _callee4);
                        }));

                        return function (_x12) {
                          return _ref6.apply(this, arguments);
                        };
                      }());
                      _context5.next = 6;
                      return Promise.all(promises);

                    case 6:
                      return _context5.abrupt("return", _context5.sent.filter(function (c) {
                        return c;
                      }));

                    case 7:
                    case "end":
                      return _context5.stop();
                  }
                }
              }, _callee5);
            }))();

          case 3:
            response.courses = _context8.sent;
            _context8.next = 6;
            return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
              var productIds, promises;
              return _regeneratorRuntime.wrap(function _callee7$(_context7) {
                while (1) {
                  switch (_context7.prev = _context7.next) {
                    case 0:
                      if (!((recommend === null || recommend === void 0 ? void 0 : recommend.type) !== "tvod")) {
                        _context7.next = 2;
                        break;
                      }

                      return _context7.abrupt("return", null);

                    case 2:
                      productIds = Array.isArray(recommend.id) ? recommend.id : [recommend.id];
                      promises = productIds.map( /*#__PURE__*/function () {
                        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id) {
                          var product;
                          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
                            while (1) {
                              switch (_context6.prev = _context6.next) {
                                case 0:
                                  _context6.next = 2;
                                  return dataSources.product.productById({
                                    id: id
                                  });

                                case 2:
                                  product = _context6.sent;

                                  if (!purchaseAllowed(product)) {
                                    _context6.next = 7;
                                    break;
                                  }

                                  return _context6.abrupt("return", product);

                                case 7:
                                  return _context6.abrupt("return", null);

                                case 8:
                                case "end":
                                  return _context6.stop();
                              }
                            }
                          }, _callee6);
                        }));

                        return function (_x13) {
                          return _ref8.apply(this, arguments);
                        };
                      }());
                      _context7.next = 6;
                      return Promise.all(promises);

                    case 6:
                      return _context7.abrupt("return", _context7.sent.filter(function (p) {
                        return p;
                      }));

                    case 7:
                    case "end":
                      return _context7.stop();
                  }
                }
              }, _callee7);
            }))();

          case 6:
            response.products = _context8.sent;
            return _context8.abrupt("return", response);

          case 8:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _normalization.apply(this, arguments);
}

var viewingArticleSchema = y.object({
  type: y.string().oneOf(["tvod", "svod"]),
  id: y.array(y.number())
});
export var resolvers = {
  Query: {
    /**
     * recommendArticle
     *
     * Cookieに保存されたデータからレコメンドする商品を返す
     */
    recommendArticle: function () {
      var _recommendArticle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_parent, _args, _ref) {
        var req, res, dataSources, viewingArticle, response, recommend;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                req = _ref.req, res = _ref.res, dataSources = _ref.dataSources;
                viewingArticle = new ViewingArticle(req, res);
                response = {
                  courses: null,
                  products: null
                };
                _context.prev = 3;
                recommend = viewingArticle.get();
                _context.next = 7;
                return normalization(recommend, dataSources);

              case 7:
                return _context.abrupt("return", _context.sent);

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                console.log("recommend article Error", _context.t0);
                return _context.abrupt("return", response);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10]]);
      }));

      function recommendArticle(_x3, _x4, _x5) {
        return _recommendArticle.apply(this, arguments);
      }

      return recommendArticle;
    }()
  },
  Mutation: {
    /**
     * updateRecommendArticle
     *
     * レコメンドする商品を保存する
     */
    updateRecommendArticle: function () {
      var _updateRecommendArticle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_parent, _ref2, _ref3) {
        var type, id, req, res, dataSources, recommend, viewingArticle;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                type = _ref2.type, id = _ref2.id;
                req = _ref3.req, res = _ref3.res, dataSources = _ref3.dataSources;
                _context2.prev = 2;
                _context2.next = 5;
                return viewingArticleSchema.validate({
                  type: type,
                  id: id
                }, {
                  stripUnknown: true
                });

              case 5:
                recommend = _context2.sent;
                viewingArticle = new ViewingArticle(req, res);
                viewingArticle.set(recommend);
                _context2.next = 10;
                return normalization(recommend, dataSources);

              case 10:
                return _context2.abrupt("return", _context2.sent);

              case 13:
                _context2.prev = 13;
                _context2.t0 = _context2["catch"](2);
                console.log(_context2.t0);
                return _context2.abrupt("return", null);

              case 17:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 13]]);
      }));

      function updateRecommendArticle(_x6, _x7, _x8) {
        return _updateRecommendArticle.apply(this, arguments);
      }

      return updateRecommendArticle;
    }(),

    /**
     * clearRecommendArticle
     *
     * レコメンドする商品をクリアする
     */
    clearRecommendArticle: function () {
      var _clearRecommendArticle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_parent, _args, _ref4) {
        var req, res, viewingArticle;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                req = _ref4.req, res = _ref4.res;
                viewingArticle = new ViewingArticle(req, res);
                viewingArticle.delete();
                return _context3.abrupt("return", {
                  courses: null,
                  products: null
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function clearRecommendArticle(_x9, _x10, _x11) {
        return _clearRecommendArticle.apply(this, arguments);
      }

      return clearRecommendArticle;
    }()
  }
};